const allowDrop = (event) => {
    event.preventDefault()
}

const handleDragStart = (event) => {
    event.dataTransfer.setData("text", event.target.id)
}

const drop = (event) => {
    event.preventDefault()

    const data = event.dataTransfer.getData("text")
    const etudeCard = document.getElementById(data)
    const colonne = event.target.closest('.colonner-part')
    if (!colonne) return

    const newStatus = colonne.getAttribute('data-status')
    const confirmation = window.confirm("Confirmez-vous la mise à jour de l'étude ?")

    if (confirmation) {
        const partContent = colonne.querySelector('.part-content')
        if (partContent && etudeCard) {
            partContent.appendChild(etudeCard)
        }
        updateEtudeStatus(data.split('-')[1], newStatus)
    }
}

const updateEtudeStatus = (etudeId, newStatus) => {
    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.getAttribute('content')
    const etudeElement = document.getElementById(`etude-${etudeId}`)
    if (!etudeElement) return

    const juniorId = etudeElement.getAttribute('data-junior-id')
    const url = `/juniors/${juniorId}/etudes/${etudeId}`

    const bodyData = { statut: newStatus }

    fetch(url, {
        method: 'PATCH',
        headers: {
            'Content-Type': 'application/json',
            'X-CSRF-Token': csrfToken,
        },
        body: JSON.stringify(bodyData)
    })
        .then(response => {
            if (!response.ok) {
                throw new Error('La mise à jour a échoué')
            }
            return response.json()
        })
        .then(() => {
            window.location.reload()
        })
        .catch(error => {
            console.error('Erreur lors de la mise à jour:', error)
            window.location.reload()
        })
}

const initDragAndDrop = () => {
    // skip drag&drop sur mobile
    if (/Mobi|Android/i.test(navigator.userAgent)) {
        return
    }

    const etudeCards = document.querySelectorAll('.etude-card')
    const colonnes = document.querySelectorAll('.colonner-part')

    // si pas de board drag and drop sur la page on sort
    if (etudeCards.length === 0 || colonnes.length === 0) {
        return
    }

    etudeCards.forEach(card => {
        card.setAttribute('draggable', 'true')
        card.addEventListener('dragstart', handleDragStart)

        card.addEventListener('click', (event) => {
            const etudeId = event.currentTarget.id.split('-')[1]
            const juniorId = event.currentTarget.getAttribute('data-junior-id')
            window.location.href = `/juniors/${juniorId}/etudes/${etudeId}`
        })
    })

    colonnes.forEach(colonne => {
        colonne.addEventListener('dragover', allowDrop)
        colonne.addEventListener('drop', drop)
    })
}

export { initDragAndDrop }
